export enum SalesforceActionId {
    Create = 1,
    Update = 2,
    Ignore = 3,
  }